// extracted by mini-css-extract-plugin
export default {"form":"CurrencyRuleForm_form__Qum6+","form__button":"CurrencyRuleForm_form__button__XwMfu"};